// Subscription Flow JS
(function() {
    var $window     = $( window ),
        $coffee     = $('.coffee-wrapper ul li'),
        $blend      = $('.blend-wrapper ul li'),
        $gift       = $('.gift-wrapper ul li'),
        $freeCoffee = $('.coffee-wrapper-free-trial ul li'),
        $freeBlend  = $('.blend-wrapper-free-trial ul li'),
        $size       = $('.size-wrapper ul li'),
        $inputQty   = $size.find('.input-wrapper'),
        $productQty = $inputQty.find('input'),
        $frequency  = $('.frequency-wrapper ul li'),
        $grindType  = $('.grind-type-wrapper ul li'),
        $selectBtn  = $('.subscription-btn'),
        $subBtn     = $('.subscribe-btn'),
        $restartBtn = $('.restart-btn'),
        productPrice,
        chargeDelay,
        subscriptionId,
        variantId,
        variantQty,
        productName,
        productSize,
        productFreq,
        productInt,
        grindType;

  $coffee.on('click', function() {
    var $this = $(this);
  
    $this.addClass('selected').siblings().removeClass('selected');
    $this.find($selectBtn).text('Selected');
    $this.siblings().find($selectBtn).text('Select');
  
    subscriptionId = $this.attr('data-subscription');
    productName = $this.attr('data-title');
    variantId = $this.attr('data-variant');
    // console.log("productName: ", productName)
  
    $('.sizes').hide();
    updateVariantForBlend(productName, decafVariantMap);
  
    if (productName === 'Single Origin Subscription') {
      $('.sizes.single-origin-subscription').show();
  
      // // setting the default variant for quantity = 1
      setDefaultVariants();
  
      // // Listen for quantity changes on the size items
      $('.single-origin-subscription .quantity__input').on('change', function() {
        var quantity = $(this).val();
        console.log('Quantity changed to: ', quantity);
        var $sizeItem = $(this).closest('.size-item'); // finding the closest size-item element
        console.log('$sizeItem changed to: ', $sizeItem);
        var sizeTitle = $sizeItem.attr('data-title'); // getting the size (e.g., "250g", "2lb", etc.)
        console.log('sizeTitle changed to: ', sizeTitle);
        
        updateVariantForQuantity(quantity, sizeTitle); 
      });
      // var $selectedSizeItem = $('.size-item.selected');
      // console.log("$selectedSizeItem", $selectedSizeItem);if ($selectedSizeItem.length > 0) {
      // // Get the variant ID from the selected size's dataset
      // variantId = $selectedSizeItem.attr('data-variant');
      
      // // Update the subscription button with the correct variant ID
      // $subBtn.attr({
      //     'data-subscription': subscriptionId,
      //     'data-variant': variantId
      //   });
      // }
      
      // $size[0].dataset.variant = 12419056774; // 250g
      // $size[1].dataset.variant = 43024719020168; // 1lb
      // $size[2].dataset.variant = 14455259014; // 2lb
      // $size[3].dataset.variant = 14455259078; // 5lb

      // $size[0].dataset.price = 21.00; // 250g
      // $size[1].dataset.price = 34.36; // 1lb
      // $size[2].dataset.price = 61.09; // 2lb
      // $size[3].dataset.price = 124.09; // 5lb
      
    } else if (productName === 'Decaf') {
      $('.sizes.default-sizes').show();
      $('.size-item, .grind-item').on('click', function() {
        var selectedSize = $('.size-item.selected').attr('data-title');
        var selectedGrind = $('.grind-type-wrapper .grind-item.selected').attr('data-grind-type');
  
        // Proceed only if both a size and grind type are selected
        if (selectedSize && selectedGrind) {
          // console.log("Selected Size: ", selectedSize);
          // console.log("Selected Grind: ", selectedGrind);
  
          // Fetch the correct variant based on size and grind type
          if (decafVariantMap[selectedSize] && decafVariantMap[selectedSize][selectedGrind]) {
            var variantData = decafVariantMap[selectedSize][selectedGrind];
            variantId = variantData.variant;
            productPrice = variantData.price;
            // console.log("Updated Variant ID: ", variantId, "Price: ", productPrice);
  
            // Update the subscribe button with the correct variant ID
            $subBtn.attr({
              'data-variant': variantId,
              'data-price': productPrice
            });
            updateBlendPrice(decafVariantMap);
          } else {
            // console.error("Error: Could not find matching variant for selected size and grind.");
          }
        } else {
          // console.error("Error: Please select a size and grind type for All Day Blend.");
        }
      });
    }
  
    $('.summary-item.coffee .summary-item__name span').text(productName);
  
    $subBtn.attr({
      'data-subscription': subscriptionId,
      'data-variant': variantId
    });
  
    if ($this.hasClass('blends')) {
      $('.blend-wrapper').fadeIn();
    } else {
      $('.size-wrapper').fadeIn();
      $('.blend-wrapper').fadeOut();
    }
  
    $size.removeClass('selected');
    $size.find($selectBtn).text('Select');
    $productQty.val(1);
    $size.attr('data-quantity', 1);
  
    $size.trigger('datachange');
  
    setTimeout(function() {
      if ($this.hasClass('blends')) {
        $('html, body').animate({
          scrollTop: $('.blend-wrapper').offset().top - 200
        }, 500);
      } else {
        $('html, body').animate({
          scrollTop: $('.size-wrapper').offset().top - 200
        }, 500);
      }
    }, 500);
  });

  const allDayVariantMap = {
    '250G': {
      'Whole Bean': {
        variant: 42847351603336,
        price: 16.99
      },
      'Drip Grind': {
        variant: 42847351668872, 
        price: 16.99
      },
      'Coarse Grind': {
        variant: 42847351701640, 
        price: 16.99
      },
      'Pour Over Grind': {
        variant: 42847351734408, 
        price: 16.99
      }
    },
    '1LB': {
      'Whole Bean': {
        variant: 42847351767176,
        price: 27.80
      },
      'Drip Grind': {
        variant: 42847351799944, 
        price: 27.80
      },
      'Coarse Grind': {
        variant: 42847351832712, 
        price: 27.80
      },
      'Pour Over Grind': {
        variant: 42847351865480, 
        price: 27.80
      }
    },
    '2LB': {
      'Whole Bean': {
        variant: 42847351931016,
        price: 49.43
      },
      'Drip Grind': {
        variant: 42847351963784, 
        price: 49.43
      },
      'Coarse Grind': {
        variant: 42847351996552, 
        price: 49.43
      },
      'Pour Over Grind': {
        variant: 42847352029320, 
        price: 49.43
      }
    },
    '5LB': {
      'Whole Bean': {
        variant: 42847352062088,
        price: 115.84
      },
      'Drip Grind': {
        variant: 42847352094856, 
        price: 115.84
      },
      'Coarse Grind': {
        variant: 42847352127624, 
        price: 115.84
      },
      'Pour Over Grind': {
        variant: 42847352160392, 
        price: 115.84
      }
    }
  };
  
  const foundationVariantMap = {
    '250G': {
      'Whole Bean': {
        variant: 41368928649352,
        price: 16.99
      },
      'Drip Grind': {
        variant: 41368928682120, 
        price: 16.99
      },
      'Coarse Grind': {
        variant: 41368928714888, 
        price: 16.99
      },
      'Pour Over Grind': {
        variant: 41368928747656, 
        price: 16.99
      }
    },
    '1LB': {
      'Whole Bean': {
        variant: 41368933761160,
        price: 27.80
      },
      'Drip Grind': {
        variant: 41368933793928, 
        price: 27.80
      },
      'Coarse Grind': {
        variant: 41368933826696, 
        price: 27.80
      },
      'Pour Over Grind': {
        variant: 41368933859464, 
        price: 27.80
      }
    },
    '2LB': {
      'Whole Bean': {
        variant: 41368928780424,
        price: 49.43
      },
      'Drip Grind': {
        variant: 41368928813192, 
        price: 49.43
      },
      'Coarse Grind': {
        variant: 41368928845960, 
        price: 49.43
      },
      'Pour Over Grind': {
        variant: 41368928878728, 
        price: 49.43
      }
    },
    '5LB': {
      'Whole Bean': {
        variant: 41368928911496,
        price: 115.84
      },
      'Drip Grind': {
        variant: 41368928944264, 
        price: 115.84
      },
      'Coarse Grind': {
        variant: 41368928977032, 
        price: 115.84
      },
      'Pour Over Grind': {
        variant: 41368929009800, 
        price: 115.84
      }
    }
  };
  const keystoneVariantMap = {
    '250G': {
      'Whole Bean': {
        variant: 41368958566536,
        price: 18.99
      },
      'Drip Grind': {
        variant: 41368958599304, 
        price: 18.99
      },
      'Coarse Grind': {
        variant: 41368958632072, 
        price: 18.99
      },
      'Pour Over Grind': {
        variant: 41368958664840, 
        price: 18.99
      }
    },
    '1LB': {
      'Whole Bean': {
        variant: 41368960499848,
        price: 31.07
      },
      'Drip Grind': {
        variant: 41368960532616, 
        price: 31.07
      },
      'Coarse Grind': {
        variant: 41368960565384, 
        price: 31.07
      },
      'Pour Over Grind': {
        variant: 41368960598152, 
        price: 31.07
      }
    },
    '2LB': {
      'Whole Bean': {
        variant: 41368958697608,
        price: 55.24
      },
      'Drip Grind': {
        variant: 41368958730376, 
        price: 55.24
      },
      'Coarse Grind': {
        variant: 41368958763144, 
        price: 55.24
      },
      'Pour Over Grind': {
        variant: 41368958795912, 
        price: 55.24
      }
    },
    '5LB': {
      'Whole Bean': {
        variant: 41368958828680,
        price: 129.48
      },
      'Drip Grind': {
        variant: 41368958861448, 
        price: 129.48
      },
      'Coarse Grind': {
        variant: 41368958894216, 
        price: 129.48
      },
      'Pour Over Grind': {
        variant: 41368958926984, 
        price: 129.48
      }
    }
  };
  const kensingtonVariantMap = {
    '250G': {
      'Whole Bean': {
        variant: 41368956010632,
        price: 17.99
      },
      'Drip Grind': {
        variant: 41368956043400, 
        price: 17.99
      },
      'Coarse Grind': {
        variant: 41368956076168, 
        price: 17.99
      },
      'Pour Over Grind': {
        variant: 41368956108936, 
        price: 17.99
      }
    },
    '1LB': {
      'Whole Bean': {
        variant: 41368958206088,
        price: 29.44
      },
      'Drip Grind': {
        variant: 41368958238856, 
        price: 29.44
      },
      'Coarse Grind': {
        variant: 41368958304392, 
        price: 29.44
      },
      'Pour Over Grind': {
        variant: 41368958271624, 
        price: 29.44
      }
    },
    '2LB': {
      'Whole Bean': {
        variant: 41368956141704,
        price: 52.33
      },
      'Drip Grind': {
        variant: 41368956174472, 
        price: 52.33
      },
      'Coarse Grind': {
        variant: 41368956240008, 
        price: 52.33
      },
      'Pour Over Grind': {
        variant: 41368956207240, 
        price: 52.33
      }
    },
    '5LB': {
      'Whole Bean': {
        variant: 41368956272776,
        price: 122.66
      },
      'Drip Grind': {
        variant: 41368956305544, 
        price: 122.66
      },
      'Coarse Grind': {
        variant: 41368956371080, 
        price: 122.66
      },
      'Pour Over Grind': {
        variant: 41368956338312, 
        price: 122.66
      }
    }
  };

  const decafVariantMap = {
    '250G': {
      'Whole Bean': {
        variant: 41368935006344,
        price: 19.99
      },
      'Drip Grind': {
        variant: 41368935039112, 
        price: 19.99
      },
      'Coarse Grind': {
        variant: 41368935071880, 
        price: 19.99
      },
      'Pour Over Grind': {
        variant: 41368935104648, 
        price: 19.99
      }
    },
    '1LB': {
      'Whole Bean': {
        variant: 41368937398408,
        price: 32.71
      },
      'Drip Grind': {
        variant: 41368937431176, 
        price: 32.71
      },
      'Coarse Grind': {
        variant: 41368937463944, 
        price: 32.71
      },
      'Pour Over Grind': {
        variant: 41368937496712, 
        price: 32.71
      }
    },
    '2LB': {
      'Whole Bean': {
        variant: 41368935137416,
        price: 58.15
      },
      'Drip Grind': {
        variant: 41368935170184, 
        price: 58.15
      },
      'Coarse Grind': {
        variant: 41368935202952, 
        price: 58.15
      },
      'Pour Over Grind': {
        variant: 41368935235720, 
        price: 58.15
      }
    },
    '5LB': {
      'Whole Bean': {
        variant: 41368935268488,
        price: 136.30
      },
      'Drip Grind': {
        variant: 41368935301256, 
        price: 136.30
      },
      'Coarse Grind': {
        variant: 41368935334024, 
        price: 136.30
      },
      'Pour Over Grind': {
        variant: 41368935366792, 
        price: 136.30
      }
    }
  };



  const singleOriginPriceMap = {
    '12419056774': 21.00,
    '43024719020168': 34.36,
    '14455259014': 61.09,
    '14455259078': 124.09,
    '14455259142': 35.00,
    '14455259206': 79.50,
    '14455259270': 192.50, 
    '14455259334': 50.00,
    '14455259398': 119.25,
    '14455259462': 288.75
  }

  function updatePrice() {
      var $selectedItem = $('.single-origin-subscription .size-item.selected');

      var $selectedGiftItem = $('.gift-wrapper .gift-item.selected');
    
      var variantId = $selectedItem.attr('data-variant');
      var price = singleOriginPriceMap[variantId];
    
      if ($selectedItem.length > 0 && price) {
        // If the price exists in the price map, update the DOM
        // console.log("selectedItem found")
        // console.log('Updating price for variant:', variantId, 'with price:', price);
        $('.summary-price .order-item__price').text(`$${price.toFixed(2)}`);
        $('.order-item--total .order-item__price').text(`$${price.toFixed(2)}`);
      } else if ($selectedGiftItem.length > 0) {
        // console.log("selected Gift item found")
        var giftPrice = parseFloat($selectedGiftItem.attr('data-prepaid-price'));
        $('.summary-price .order-item__price').text(`$${giftPrice.toFixed(2)}`);
        $('.order-item--total .order-item__price').text(`$${giftPrice.toFixed(2)}`);
      } else {
        // If no price found, set it to $NaN (for debugging, this can be removed)
        // console.log('No price found for variant:', variantId);
        $('.summary-price .order-item__price').text('$NaN');
        $('.order-item--total .order-item__price').text('$NaN');
      }
  }

  function updateBlendPrice(variantMap) {
    // Get the selected size and grind elements
    var selectedSize = $('.size-item.selected').attr('data-title');
    var selectedGrind = $('.grind-type-wrapper .grind-item.selected').attr('data-grind-type');
  
    // Validate that both size and grind type are selected
    if (!selectedSize || !selectedGrind) {
      console.error("Error: Size and Grind Type must be selected to update the price.");
      $('.summary-price .order-item__price').text('$NaN');
      $('.order-item--total .order-item__price').text('$NaN');
      return;
    }
  
    // Get the variant data using the selected size and grind type
    var variantData = variantMap[selectedSize] ? variantMap[selectedSize][selectedGrind] : null;
  
    // Check if the variant data is available
    if (variantData) {
      var price = variantData.price;
      // console.log("Updating price for size:", selectedSize, "grind:", selectedGrind, "with price:", price);
  
      // Update the price in the DOM
      $('.summary-price .order-item__price').text(`$${price.toFixed(2)}`);
      $('.order-item--total .order-item__price').text(`$${price.toFixed(2)}`);
    } else {
      // If no variant data found, set price to $NaN for debugging
      console.error("Error: No matching variant found for selected size and grind type.");
      $('.summary-price .order-item__price').text('$NaN');
      $('.order-item--total .order-item__price').text('$NaN');
    }
  }



  // Function to set the default variant (quantity 1) for each size when showing the sizes initially
  function setDefaultVariants() {
    $('.single-origin-subscription .size-item.250g').attr('data-variant', '12419056774'); // 250g, quantity 1
    $('.single-origin-subscription .size-item.1lb').attr('data-variant', '43024719020168'); // 1lb, quantity 1
    $('.single-origin-subscription .size-item.2lb').attr('data-variant', '14455259014'); // 2lb, quantity 1
    $('.single-origin-subscription .size-item.5lb').attr('data-variant', '14455259078'); // 5lb, quantity 1
  }
  
  // Function to update the variant based on the selected quantity
  function updateVariantForQuantity(quantity, sizeTitle) {
      // console.log('Updating variant for size: ', sizeTitle, ' with quantity: ', quantity);
  
      var variantId, price;
  
      if (sizeTitle === '250G') {
          if (quantity == 1) {
              variantId = '12419056774';
              price = 21.00;
          } else if (quantity == 2) {
              variantId = '12419056774';
              price = 42.00;
          } else if (quantity == 3) {
              variantId = '12419056774';
              price = 63.00;
          }
      } else if (sizeTitle === '1LB') {
          if (quantity == 1) {
              variantId = '43024719020168';
              price = 34.36;
          } else if (quantity == 2) {
              variantId = '43024719020168';
              price = 68.72;
          } else if (quantity == 3) {
              variantId = '43024719020168';
              price = 103.08;
          }
      } else if (sizeTitle === '2LB') {
          if (quantity == 1) {
              variantId = '14455259014';
              price = 61.09;
          } else if (quantity == 2) {
              variantId = '14455259014';
              price = 122.18;
          } else if (quantity == 3) {
              variantId = '14455259014';
              price = 183.27;
          }
      } else if (sizeTitle === '5LB') {
          if (quantity == 1) {
              variantId = '14455259078';
              price = 124.09;
          } else if (quantity == 2) {
              variantId = '14455259078';
              price = 248.00;
          } else if (quantity == 3) {
              variantId = '14455259078';
              price = 372.27;
          }
      }
  
      // Update the size item with both the variant ID and price
      $(`.single-origin-subscription .size-item.${sizeTitle.toLowerCase()}`).attr('data-variant', variantId);
      $(`.single-origin-subscription .size-item.${sizeTitle.toLowerCase()}`).attr('data-price', price);
  
      // Directly update the price in the DOM
      updatePrice();
  }

  // Reusable function to update variant and price based on size and grind type
  function updateVariantForBlend(productName, variantMap) {
    // Get the selected size (e.g., "250g", "1lb", etc.)
    var selectedSize = $('.size-item.selected').attr('data-title');
    
    // Get the selected grind type (e.g., "Whole Bean", "Drip Grind", etc.)
    var selectedGrind = $('.grind-type-wrapper .grind-item.selected').attr('data-grind-type');
  
    if (selectedSize && selectedGrind) {
      // console.log(`Selected Size for ${productName}:`, selectedSize);
      // console.log(`Selected Grind for ${productName}:`, selectedGrind);
  
      // Fetch the correct variant based on size and grind type
      if (variantMap[selectedSize] && variantMap[selectedSize][selectedGrind]) {
        var variantData = variantMap[selectedSize][selectedGrind];
        variantId = variantData.variant;
        productPrice = variantData.price;
        // console.log(`Updated Variant ID for ${productName}:`, variantId, "Price:", productPrice);
        
        // Update the subscribe button attributes with the selected variant details
        $subBtn.attr({
          'data-variant': variantId,
          'data-price': productPrice
        });
        
        // Update the price in the order summary
        updatePrice(variantId);
      } else {
        console.log(`Error: Could not find matching variant for ${productName} with selected size and grind.`);
      }
    } else {
      console.log(`Error: Please select a size and grind type for ${productName}.`);
    }
  }

  $blend.on('click', function() {
    var $this = $(this);
  
    $this.addClass('selected').siblings().removeClass('selected');
    $this.find($selectBtn).text('Selected');
    $this.siblings().find($selectBtn).text('Select');
  
    subscriptionId = $this.attr('data-subscription');
    productName = $this.attr('data-title');
    // console.log("PROD NAME: ", productName)
  
    updateVariantForBlend(productName, allDayVariantMap);
    updateVariantForBlend(productName, foundationVariantMap);
    updateVariantForBlend(productName, keystoneVariantMap);
    updateVariantForBlend(productName, kensingtonVariantMap);
  
    if (productName === 'All Day Blend') {
      // console.log("in the all day blend if");
      $('.sizes.default-sizes').show();
      $('.size-item, .grind-item').on('click', function() {
        var selectedSize = $('.size-item.selected').attr('data-title');
        var selectedGrind = $('.grind-type-wrapper .grind-item.selected').attr('data-grind-type');
  
        // Proceed only if both a size and grind type are selected
        if (selectedSize && selectedGrind) {
          // console.log("Selected Size: ", selectedSize);
          // console.log("Selected Grind: ", selectedGrind);
  
          // Fetch the correct variant based on size and grind type
          if (allDayVariantMap[selectedSize] && allDayVariantMap[selectedSize][selectedGrind]) {
            var variantData = allDayVariantMap[selectedSize][selectedGrind];
            variantId = variantData.variant;
            productPrice = variantData.price;
            // console.log("Updated Variant ID: ", variantId, "Price: ", productPrice);
  
            // Update the subscribe button with the correct variant ID
            $subBtn.attr({
              'data-variant': variantId,
              'data-price': productPrice
            });
            updateBlendPrice(allDayVariantMap);
          } else {
            console.error("Error: Could not find matching variant for selected size and grind.");
          }
        } else {
          console.error("Error: Please select a size and grind type for All Day Blend.");
        }
      });
  
    } else if (productName === 'Foundation Blend') {
      // console.log("in the foundation if") //foundationVariantMap
      $('.sizes.default-sizes').show();
      $('.size-item, .grind-item').on('click', function() {
        var selectedSize = $('.size-item.selected').attr('data-title');
        var selectedGrind = $('.grind-type-wrapper .grind-item.selected').attr('data-grind-type');
  
        // Proceed only if both a size and grind type are selected
        if (selectedSize && selectedGrind) {
          // console.log("Selected Size: ", selectedSize);
          // console.log("Selected Grind: ", selectedGrind);
  
          // Fetch the correct variant based on size and grind type
          if (foundationVariantMap[selectedSize] && foundationVariantMap[selectedSize][selectedGrind]) {
            var variantData = foundationVariantMap[selectedSize][selectedGrind];
            variantId = variantData.variant;
            productPrice = variantData.price;
            // console.log("Updated Variant ID: ", variantId, "Price: ", productPrice);
  
            // Update the subscribe button with the correct variant ID
            $subBtn.attr({
              'data-variant': variantId,
              'data-price': productPrice
            });
            updateBlendPrice(foundationVariantMap);
          } else {
            console.error("Error: Could not find matching variant for selected size and grind.");
          }
        } else {
          console.error("Error: Please select a size and grind type for All Day Blend.");
        }
      });
  
    } else if (productName === 'Keystone Blend') {
      $('.sizes.default-sizes').show();
      $('.size-item, .grind-item').on('click', function() {
        var selectedSize = $('.size-item.selected').attr('data-title');
        var selectedGrind = $('.grind-type-wrapper .grind-item.selected').attr('data-grind-type');
  
        // Proceed only if both a size and grind type are selected
        if (selectedSize && selectedGrind) {
          // console.log("Selected Size: ", selectedSize);
          // console.log("Selected Grind: ", selectedGrind);
  
          // Fetch the correct variant based on size and grind type
          if (keystoneVariantMap[selectedSize] && keystoneVariantMap[selectedSize][selectedGrind]) {
            var variantData = keystoneVariantMap[selectedSize][selectedGrind];
            variantId = variantData.variant;
            productPrice = variantData.price;
            // console.log("Updated Variant ID: ", variantId, "Price: ", productPrice);
  
            // Update the subscribe button with the correct variant ID
            $subBtn.attr({
              'data-variant': variantId,
              'data-price': productPrice
            });
            updateBlendPrice(keystoneVariantMap);
          } else {
            console.error("Error: Could not find matching variant for selected size and grind.");
          }
        } else {
          console.error("Error: Please select a size and grind type for All Day Blend.");
        }
      });
  
  
    } else if (productName === 'Kensington Dark Roast Blend') {
      $('.sizes.default-sizes').show();
      $('.size-item, .grind-item').on('click', function() {
        var selectedSize = $('.size-item.selected').attr('data-title');
        var selectedGrind = $('.grind-type-wrapper .grind-item.selected').attr('data-grind-type');
  
        // Proceed only if both a size and grind type are selected
        if (selectedSize && selectedGrind) {
          // console.log("Selected Size: ", selectedSize);
          // console.log("Selected Grind: ", selectedGrind);
  
          // Fetch the correct variant based on size and grind type
          if (kensingtonVariantMap[selectedSize] && kensingtonVariantMap[selectedSize][selectedGrind]) {
            var variantData = kensingtonVariantMap[selectedSize][selectedGrind];
            variantId = variantData.variant;
            productPrice = variantData.price;
            // console.log("Updated Variant ID: ", variantId, "Price: ", productPrice);
  
            // Update the subscribe button with the correct variant ID
            $subBtn.attr({
              'data-variant': variantId,
              'data-price': productPrice
            });
            updateBlendPrice(kensingtonVariantMap);
          } else {
            console.error("Error: Could not find matching variant for selected size and grind.");
          }
        } else {
          console.error("Error: Please select a size and grind type for All Day Blend.");
        }
      });
  
    } else if (productName === 'Seasonal Blend') {
      $('.sizes.default-sizes').show();
      $size[0].dataset.variant = 22289564008533; // 250g
      $size[1].dataset.variant = 41360558391432; // 1lb
      $size[2].dataset.variant = 22289564041301; // 2lb
      $size[3].dataset.variant = 22289564074069; // 5lb
  
      $size[0].dataset.price = 20.99; // 250g
      $size[1].dataset.price = 34.35; // 1lb
      $size[2].dataset.price = 61.06; // 2lb
      $size[3].dataset.price = 143.11; // 5lb
    }
  
    $('.summary-item.coffee .summary-item__name span').text(productName);
  
    $subBtn.attr({
      'data-subscription': subscriptionId,
      'data-title': productName,
      'data-variant': variantId // Ensure the variant ID is set
    });
  
    $size.removeClass('selected');
    $size.find($selectBtn).text('Select');
    $productQty.val(1);
    $size.attr('data-quantity', 1);
  
    $('.size-wrapper').fadeIn();
  
    $size.trigger('datachange');
  
    setTimeout(function() {
      $('html, body').animate({
        scrollTop: $('.size-wrapper').offset().top - 200
      }, 500);
    }, 500);
  });


  $gift.on('click', function() {
    var $this = $(this);

    $this.addClass('selected').siblings().removeClass('selected');
    $this.find($selectBtn).text('Selected');
    $this.siblings().find($selectBtn).text('Select');

    subscriptionId = $this.attr('data-subscription');
    productName = $this.attr('data-title');

    $size[0].dataset.variant = 43145761128584; // 250g
    
    if (productName === '3 Month') {
      $size[0].dataset.price = 63.00; // 250g
    } else if (productName === '6 Month') {
      $size[0].dataset.price = 126.00; // 250g
    } else if (productName === '12 Month') {
      $size[0].dataset.price = 252.00; // 250g
    }

    $('.summary-item.summary-duration .summary-item__name span').text(productName);

    $subBtn.attr({
      'data-subscription': subscriptionId
    });

    $productQty.val(1);
    $size.attr('data-quantity', 1);
    $size.trigger('datachange');
    $size.trigger('click');
  });


  // Free Trials
  $freeCoffee.on('click', function() {
    var $this = $(this);

    $this.addClass('selected').siblings().removeClass('selected');
    $this.find($selectBtn).text('Selected');
    $this.siblings().find($selectBtn).text('Select');

    subscriptionId = $this.attr('data-subscription');
    productName = $this.attr('data-title');
    productPrice = $this.attr('data-price');
    variantId = $this.attr('data-variant');
    chargeDelay = $this.attr('data-delay');

    $('.summary-item.trial .summary-item__name span').text(productName);
    $('.order-item--total .order-item__price').text('$' + (productPrice * 1).toFixed(2));

    $subBtn.attr({
      'data-subscription': subscriptionId,
      'data-variant': variantId,
      'data-price': productPrice,
      'data-delay': chargeDelay
    });

    if ($this.hasClass('blends')) {
      $('.blend-wrapper-free-trial').fadeIn();
    } else {
      $('.summary-wrapper').addClass('summary-flex');
      $('.blend-wrapper-free-trial').fadeOut();
    }

    setTimeout(function() {
      if ($this.hasClass('blends')) {
        $('html, body').animate({
          scrollTop: $('.blend-wrapper-free-trial').offset().top - 200
        }, 500);
      } else {
        $('html, body').animate({
          scrollTop: $('.summary-wrapper').offset().top - 200
        }, 500);
      }
    }, 500);
  });

  $freeBlend.on('click', function() {
    var $this = $(this);

    $this.addClass('selected').siblings().removeClass('selected');
    $this.find($selectBtn).text('Selected');
    $this.siblings().find($selectBtn).text('Select');

    subscriptionId = $this.attr('data-subscription');
    productName = $this.attr('data-title');
    productPrice = $this.attr('data-price');
    variantId = $this.attr('data-variant');
    chargeDelay = $this.attr('data-delay');

    $('.summary-item.trial .summary-item__name span').text(productName);
    $('.order-item--total .order-item__price').text('$' + (productPrice * 1).toFixed(2));

    $subBtn.attr({
      'data-subscription': subscriptionId,
      'data-variant': variantId,
      'data-price': productPrice,
      'data-delay': chargeDelay
    });

    $('.summary-wrapper').addClass('summary-flex');

    setTimeout(function() {
      $('html, body').animate({
        scrollTop: $('.summary-wrapper').offset().top - 200
      }, 500);
    }, 500);
  });

  $inputQty.on('click', function(e) {
    e.stopPropagation();

    $productQty.trigger('change');
    $size.trigger('datachange');
  });

  $productQty.on('change', function(e) {
    var $this = $(this),
        qty   = $this.val();

    $('.subscription-wrapper .quantity__button').trigger('change').trigger('datachange');

    $this.closest('li').attr({
      'data-quantity': qty
    });
  });

  $size.on('datachange', function() {
    var $this = $(this);

    variantQty = $this.attr('data-quantity');
    productPrice = $this.attr('data-price');
    productTitle = $this.attr('data-title');
    // console.log("PRODUCT TITLE: ", productTitle)
    // console.log("PRODUCT PRICE: ", productPrice)

    $('.price-breakdown .order-item.summary-price .order-item__price, .order-item--total .order-item__price').text('$' + (productPrice * variantQty).toFixed(2));
  });

  const variantPriceMap = {
    '12419056774': 21.00,  // 250g, quantity 1
    '14455259142': 35.00,  // 10oz, quantity 2
    '14455259334': 50.00,  // 10oz, quantity 3
    '43024719020168': 34.36,  // 1lb, quantity 1
    '14455259014': 61.09,  // 2lb, quantity 1
    '14455259206': 79.50,  // 2lb, quantity 2
    '14455259398': 119.25,  // 2lb, quantity 3
    '14455259078': 124.09,  // 5lb, quantity 1
    '14455259270': 192.50,  // 5lb, quantity 2
    '14455259462': 288.75  // 5lb, quantity 3
  };

  $size.on('click', function() {
    var $this = $(this),
        quantity;

    $this.addClass('selected').siblings().removeClass('selected');
    $this.find($selectBtn).text('Selected');
    $this.siblings().find($selectBtn).text('Select');

    productSize = $this.attr('data-title');
    // console.log("productSize", productSize)
    variantId = $this.attr('data-variant');
    // console.log("variantIDDD: ", variantId)

    var $selectedGiftItem = $('.gift-wrapper .gift-item.selected');

    if (variantPriceMap.hasOwnProperty(variantId) && $selectedGiftItem.length < 1) {
      productPrice = variantPriceMap[variantId];  // Use price from the map
      // console.log("Using price from map:", productPrice);
      //we're not using price map anymore
      var quantity = parseInt($('.size-item.selected').attr('data-quantity'), 10);
      updatePrice();
    } else {
      productPrice = $this.attr('data-price');  // Fallback to original logic
      // console.log("Using price from data-price:", productPrice);
      quantity = $this.find('input').val();
    }
  
    $this.attr('data-quantity', quantity);
    variantQty = $this.attr('data-quantity');

    if ($('.size-wrapper').hasClass('gift-size')) {
      $('.summary-wrapper').addClass('summary-flex');
    } else {
      $frequency.removeClass('selected');
      $frequency.find($selectBtn).text('Select');
      $('.grind-type-wrapper').fadeIn();
      $('.summary-wrapper').removeClass('summary-flex');
    }

    $subBtn.attr({
      'data-variant': variantId,
      'data-quantity': variantQty
    });

    $('.summary-item.summary-quantity .summary-item__name span').text(productSize.toLowerCase() + ' x ' + variantQty);
    $('.price-breakdown .order-item.summary-price .order-item__price, .order-item--total .order-item__price').text('$' + (productPrice * variantQty).toFixed(2));

    setTimeout(function() {
      if ($('.size-wrapper').hasClass('gift-size')) {
        $('html, body').animate({
          scrollTop: $('.summary-wrapper').offset().top - 200
        }, 500);
      } else {
        $('html, body').animate({
          scrollTop: $('.grind-type-wrapper').offset().top - 200
        }, 500);
      }
    }, 500);
  });

  $grindType.on('click', function(e) {
    var $this = $(this);

    $this.addClass('selected').siblings().removeClass('selected');
    $this.find($selectBtn).text('Selected');
    $this.siblings().find($selectBtn).text('Select');

    grindType = $this.attr('data-grind-type');

    $('.frequency-wrapper').fadeIn();

    $('.summary-item.grind-type .summary-item__name span').text(grindType);

    $subBtn.attr({
      'data-grind-type': grindType,
    });

    setTimeout(function() {
      $('html, body').animate({
        scrollTop: $('.frequency-wrapper').offset().top - 200
      }, 500);
    }, 500);
  })

  $frequency.on('click', function() {
    var $this = $(this);

    $this.addClass('selected').siblings().removeClass('selected');
    $this.find($selectBtn).text('Selected');
    $this.siblings().find($selectBtn).text('Select');

    productInt = $this.attr('data-interval');
    productFreq = $this.attr('data-frequency');

    if ($this.hasClass('weekly')) {
      $('.summary-item.frequency .summary-item__name span').text('Weekly');
    } else if ($this.hasClass('biweekly')) {
      $('.summary-item.frequency .summary-item__name span').text('Biweekly');
    } else if ($this.hasClass('triweekly')) {
      $('.summary-item.frequency .summary-item__name span').text('Triweekly');
    } else if ($this.hasClass('monthly')) {
      $('.summary-item.frequency .summary-item__name span').text('Monthly');
    }

    $subBtn.attr({
      'data-frequency': productFreq,
      'data-interval': productInt,
    });

    let subscribeBtn = document.querySelector('.main-subscription-wrapper .subscribe-btn')
    if(subscribeBtn){
      subscribeBtn.setAttribute("is-smartrr", "true")
    }

    $('.summary-wrapper').addClass('summary-flex');

    setTimeout(function() {
      $('html, body').animate({
        scrollTop: $('.summary-wrapper').offset().top - 200
      }, 500);
    }, 500);
  });

  $('.summary-item.coffee .summary-item__btn').on('click', function() {
    $('html, body').animate({
      scrollTop: $('.coffee-wrapper').offset().top - 200
    }, 500);
  });

  $('.summary-item.summary-duration .summary-item__btn').on('click', function() {
    $('html, body').animate({
      scrollTop: $('.gift-wrapper').offset().top - 200
    }, 500);
  });

  $('.summary-item.trial .summary-item__btn').on('click', function() {
    $('html, body').animate({
      scrollTop: $('.coffee-wrapper-free-trial').offset().top - 200
    }, 500);
  });

  $('.summary-item.summary-quantity .summary-item__btn').on('click', function() {
    $('html, body').animate({
      scrollTop: $('.size-wrapper').offset().top - 200
    }, 500);
  });

  $('.summary-item.grind-type .summary-item__btn').on('click', function() {
    $('html, body').animate({
      scrollTop: $('.grind-type-wrapper').offset().top - 200
    }, 500);
  });

  $('.summary-item.frequency .summary-item__btn').on('click', function() {
    $('html, body').animate({
      scrollTop: $('.frequency-wrapper').offset().top - 200
    }, 500);
  });

  function addItemToCart (variant_id, quantity, shipping_interval_frequency, shipping_interval_unit_type, subscription_id, recurring_price, charge_delay, grind_type, sellingPlan="") {
    data = {
      "quantity": quantity,
      "id": variant_id,
      "properties[shipping_interval_frequency]": shipping_interval_frequency,
      "properties[shipping_interval_unit_type]": shipping_interval_unit_type,
      "properties[subscription_id]": subscription_id,
      "properties[recurring_price]": recurring_price,
      "properties[charge_delay]": charge_delay,
      "properties[Grind Type]": grind_type,
      "note": grind_type ? "Grind Type: " + grind_type : '',
    }

    if (sellingPlan) {
      data["selling_plan"] = sellingPlan;
    }

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() {
        window.location.href = '/cart';
      }
    });
  }

  $subBtn.on('click', function() {
    var $this        = $(this),
        // variant      = $this.attr('data-variant'),
        quantity     = $this.attr('data-quantity'),
        frequency    = $this.attr('data-frequency'),
        grindType    = $this.attr('data-grind-type'),
        interval     = $this.attr('data-interval'),
        subscription = $this.attr('data-subscription'),
        price        = $this.attr('data-price'),
        delay        = $this.attr('data-delay'),
        isSmartrr    = $this.attr('is-smartrr');

    let variant = $this.attr('data-variant');
    console.log("data-subscription: ", subscription);
      
    if (productName === 'Single Origin Subscription') {
      quantity = 1;  // always set to 1, as the variant already accounts for multiple units
      var selectedSizeItem = $('.single-origin-subscription .size-item.selected');
      variant = selectedSizeItem.attr('data-variant');
    }

    if (subscription === 'prepaid') {
      var selectedSellingPlan = $('.gift-wrapper .gift-item.selected').attr('data-selling-plan');
      console.log("selectedSellingPlan: ", selectedSellingPlan);
      addItemToCart(variant, quantity, frequency, interval, subscription, price, delay, grindType, selectedSellingPlan);
    } else {
      let sellingPlan = "";
      if(isSmartrr == "true"){
        if(frequency == "1" && interval == "week"){
          sellingPlan = "3512402056"
        }else if(frequency == "2" && interval == "weeks"){
          sellingPlan = "3512434824"
        }else if(frequency == "3" && interval == "weeks"){
          sellingPlan = "3512467592"
        }else if(frequency == "4" && interval == "weeks"){
          sellingPlan = "3512500360"
        }
      }
      if(sellingPlan){
        addItemToCart(variant, quantity, frequency, interval, subscription, price, delay, grindType, sellingPlan);
      }else{
        addItemToCart(variant, quantity, frequency, interval, subscription, price, delay, grindType);
      }
    }

  });

  $restartBtn.on('click', function() {
    $window.on('beforeunload', function() {
      $('html, body').animate({
        scrollTop: 0
      });
    });

    window.location.reload(true);
  });
})();

//
// Nimble Form Validation
//
(function() {
  var $form = $('form.contact-form');

  // because we can skip all this
  if ( $form.length > 0 ) {
      var errors = [];
      var revalidated = [];

      // super simple version of email filter, because we don't want to get overzealous with this one
      var emailFilter = /^[^@]+@[^@.]+\.[^@]*\w\w$/;

      var console = window.console || {};
          console.log = console.log || {};

      var getFieldName = function( $field ) {
          var name = $field.attr('name');
          var fieldName = name.substring( name.lastIndexOf("[") + 1, name.lastIndexOf("]") );
          var fieldNameNamespaces = fieldName.split('__');

          // if there is a __, it is a grouped field, and the first part is the main field name
          fieldName = fieldNameNamespaces[0];

          return fieldName;
      };

      var addError = function( $field, message ) {
          var fieldName = getFieldName( $field );

          if ( typeof errors === 'undefined' ) {
              errors = [];
          }

          if ( typeof errors[ fieldName ] === 'undefined') {
              errors[ fieldName ] = [];
          }

          errors[ fieldName ].push( message );
      };

      var displayErrors = function( $field ) {
          var fieldName = getFieldName( $field );
          var $container = $('.contact-form__' + fieldName );
          var $error = $container.children('.mdl-error');

          if ( $container.length < 1 ) {
              console.log('Validator: could not find element: ' + fieldName );
              return;
          }

          if ( $error.length < 1 ) {
              $error = $('<span class="mdl-textfield__error mdl-error"></span>').appendTo( $container );
          }

          $error.empty();

          if ( typeof errors !== 'undefined' && typeof errors[ fieldName ] !== 'undefined' && errors[ fieldName ].length > 0 ) {
              var currentErrors = errors[ fieldName ];

              for (var e = 0; e < currentErrors.length; e++) {
                  var error = currentErrors[e];
                  var $error = $error.text( error );

                  // only one per field... lol
                  break;
              }

              $container.addClass('is-invalid');
          } else {
              $container.removeClass('is-invalid');
          }
      };

      var clearErrors = function( $field ) {
          var fieldName = getFieldName( $field );

          errors[ fieldName ] = [];
      };

      var validateNotEmpty = function( $field ) {
          return ( !! $field.val() );
      };

      var validateEmailsMatch = function( $field ) {
          var $email = $('.contact-form__email :input');

          return ( $field.val() === $email.val() );
      };

      var validateEmail = function( $field ) {
          var email = $field.val().replace(/^\s+|\s+$/, ''); // trimmed

          // super simple, because email validation is hard
          return email.length < 256 && emailFilter.test( email );
      };

      var validatePhone = function( $field ) {
          var valid = true;
          var invalid; // laziness
          var phone = $field.val();

          if ( phone !== '' ) {

              // replace special characters and extension
              phone = phone.replace(/[\(\)\.\-\ ]/g, '');

              var phoneParts = phone.split('extension');

              if ( typeof phoneParts[1] === 'undefined' ) {
                  phoneParts = phone.split('ext');
              }

              if ( typeof phoneParts[1] === 'undefined' ) {
                  phoneParts = phone.split('x');
              }

              // check regular phone number
              phone = phoneParts[0];

              invalid = isNaN( parseInt( phone ) );

              if ( ! invalid ) {
                  invalid = phone.length < 7 || phone.length > 16;
              }

              // check extension
              if ( ! invalid && typeof phoneParts[1] !== 'undefined' ) {

                  invalid = isNaN( parseInt( phoneParts[1] ) );

                  if ( ! invalid ) {
                      invalid = phoneParts[1].length > 6;
                  }
              }

              valid = ! invalid;
          }

          return valid;
      };

      // allow empty. if can't be empty, also use validateNotEmpty validator
      var validateURL = function( $field ) {
          var url = $field.val();

          return ( url === '' || /^(?:(?:(?:https?|ftp):)?\/\/)?(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})).?)(?::\d{2,5})?(?:[/?#]\S*)?$/i.test( url ) );
      };

      // check if one of a group of checkboxes was checked
      var validateNotAllUnchecked = function( $fields ) {
          return ( $fields.filter(':checked').length > 0 );
      }

      var revalidateInput = function( $field, validations ) {
          var thisFunc = function(event) {
              var valid;

              valid = validateInput( $field, validations );

              displayErrors( $field );
          };
          var bounceTime = 850;

          // Keyup is for quick validation while typing
          // Click is for changing select dropdowns
          $field.on('change', thisFunc );
          $field.on('keyup', _.debounce(thisFunc, bounceTime) );

          if ( getFieldName( $field ) === 'confirm_email' ) {
              var $emailField = $('.contact-form__email :input');

              $emailField.on('change', bounceTime);
              $emailField.on('keyup', _.debounce(thisFunc, bounceTime) );
          }
      };

      var validateInput = function( $field, validations ) {
          var valid = true;

          clearErrors( $field );

          if ( typeof validations === 'undefined' )
              return valid; // give up

          if ( typeof validations === 'function' || typeof validations.validator === 'function' ) {
              validations = [ validations ];
          }

          if ( validations.length > 0 ) {
              var validationsLength = validations.length;

              for (var v = 0; v < validationsLength; v++) {
                  var validator = validations[v];
                  var message = "Please review the information in this field.";

                  if ( typeof validator.validator === 'function' ) {
                      message = validator.message;
                      validator = validator.validator;
                  }

                  if ( typeof validator === 'function' ) {
                      valid = validator( $field );

                      if ( ! valid ) {
                          addError( $field, message );
                      }

                  } else {
                      console.log( validator + ' is not a valid validator');
                  }

                  if ( ! valid ) {
                      break;
                  }
              }

              displayErrors( $field );
          }

          return valid;
      };

      var validateAllInputs = function() {
          var formIsValid = true;
          var currentFieldIsValid;

          var $fields = {
              name: {
                  validator: validateNotEmpty,
                  message: "Please enter your name."
              },
              email: [
                  {
                      validator: validateNotEmpty,
                      message: "Please enter your email address."
                  },
                  {
                      validator: validateEmail,
                      message: "Please enter a valid email address."
                  }
              ],
              confirm_email: [
                  {
                      validator: validateNotEmpty,
                      message: "Please confirm your email address."
                  },
                  {
                      validator: validateEmailsMatch,
                      message: "Email addresses do not match."
                  }
              ],
              phone: {
                  validator: validatePhone,
                  message: "Please enter a valid phone number."
              },
              subject: {
                  validator: validateNotEmpty,
                  message: "Please select a subject."
              },
              body: {
                  validator: validateNotEmpty,
                  message: "Please enter a message."
              },
              // wholesaler-specific
              business_type: {
                  validator: validateNotEmpty,
                  message: "Please select your business type."
              },
              website: {
                  validator: validateURL,
                  message: "Please enter a valid URL"
              },
              looking_for: {
                  validator: validateNotAllUnchecked,
                  message: "Please let us know what you are looking for."
              }
          }

          $.each( $fields, function( name, validations ) {
              var $field = $('.contact-form__' + name + ' :input');

              if ( $field.length > 0 ) {
                  currentFieldIsValid = validateInput( $field, validations );

                  if ( ! currentFieldIsValid && ! revalidated[ name ] ) {
                      revalidateInput( $field, validations );
                      revalidated[ name ] = true;
                  }

                  // if invalid, stay invalid
                  if ( formIsValid ) {
                      formIsValid = currentFieldIsValid;
                  }
              }
          });

          return formIsValid;
      };

      $form.on('submit', function( event ) {

        if ( ! validateAllInputs() ) {
              event.stopPropagation();
              event.preventDefault();
          }
      });

      // if the form has an error on the backend, it will set this variable to true
      if ( typeof validateAllFieldsNOW !== 'undefined' && validateAllFieldsNOW ) {
          validateAllInputs();
      }
  }
})();
